import { render } from "./PAGE.vue?vue&type=template&id=800bec04"
import script from "./PAGE.vue?vue&type=script&lang=js"
export * from "./PAGE.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__